import React from 'react';
import { useStaticQuery, graphql, Link } from "gatsby"
import parse from 'html-react-parser';
import useMediaQuery from '../hooks/useMediaQuery';
import IconUTD from "../icons/IconUTD"

const Footer = () => {
  const isAfterSmallBreakpoint = useMediaQuery("(min-width: 992px)");
  const isAfterMediumBreakpoint = useMediaQuery("(min-width: 1200px)");

  const {allWp} = useStaticQuery(graphql`
    query {
      allWp {
        nodes {
          footer {
            acfFooter {
              backTopButtonText
              copyright
              socialLabel
            }
          }
          socialLinks {
            acfSocialLinks {
              socialLinks {
                text
                url
                ariaLabel
                icon
              }
            }
          }
        }
      }
    }
  `);

  const settings = allWp?.nodes?.[0] ?? {};
  const footer = settings.footer?.acfFooter ?? {};
  const socialLinks = settings.socialLinks?.acfSocialLinks?.socialLinks ?? [];
  const {copyright, socialLabel} = footer;

  const currentYear = new Date().getFullYear().toString();
  let currentCopyright;
  if (copyright) {
    currentCopyright = copyright
      .replace('{{year}}', currentYear)
      .replace('2020', currentYear);
  }

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer__container">
          {isAfterSmallBreakpoint && <div className="footer__left-col"/>}

          {!isAfterSmallBreakpoint && (
            <div className="footer__right-col">
              <div className="footer__socials" tabIndex={isAfterMediumBreakpoint ? 0 : undefined}>
                <span className="footer__socials-label" aria-hidden="true">
                  {socialLabel}
                </span>

                <div className="footer__socials-hover-container">
                  <div className="footer__socials-links">
                    <span className="visually-hidden">{socialLabel}</span>
                    {socialLinks.map(({ url, ariaLabel, icon }, index) => (
                      <a
                        href={url}
                        key={index}
                        className={`footer__social-link ${index === socialLinks.length - 1 ? 'footer__social-link--last' : ''}`}
                        target="_blank"
                        rel="noreferrer"
                        aria-label={`Visit our ${ariaLabel}`}
                      >
                        {parse(icon)}
                      </a>
                    ))}
                  </div>
                </div>

                <span className="footer__socials-circle" />
              </div>
            </div>
          )}

          {copyright && (
            <div
              className="footer__copyright"
              dangerouslySetInnerHTML={{
                __html: currentCopyright
              }}
            />
          )}

          {isAfterSmallBreakpoint && (
            <div className="footer__right-col">
              <div className="footer__socials">
                <div className="footer__socials-links">
                  <span className="visually-hidden">
                    {socialLabel}
                  </span>

                  {socialLinks.map(({url, text, ariaLabel, icon}, index) => (
                    <a
                      href={url}
                      key={index}
                      className={`footer__social-link ${index === socialLinks.length - 1 ? 'footer__social-link--last' : ''}`}
                      target="_blank"
                      rel="noreferrer"
                      aria-label={`Visit our ${ariaLabel}`}
                    >
                      {parse(icon)}
                    </a>
                  ))}
                </div>

                <span className="footer__socials-label" aria-hidden="true">
                  {socialLabel}
                </span>

                <span className="footer__socials-circle"/>
              </div>
            </div>
          )}
        </div>

        <div className="footer__container">
          <div className="footer__gdpr">
            <Link
              to="/privacy-policy"
              className="iubenda-nostyle iubenda-noiframe footer__gdpr-link"
              title="Privacy Policy"
            >
              Privacy Policy
            </Link>

            <a
              href="https://www.iubenda.com/privacy-policy/40829989/cookie-policy"
              className="iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe footer__gdpr-link"
              title="Cookie Policy"
              target="_blank"
            >
              Cookie Policy
            </a>

            <a
              href="https://www.iubenda.com/terms-and-conditions/40829989"
              className="iubenda-nostyle iubenda-noiframe iubenda-embed iubenda-noiframe footer__gdpr-link"
              title="Terms and Conditions"
              target="_blank"
            >
              Terms and Conditions
            </a>

            <a
              href="/privacy-policy/#notice_at_collection"
              className="footer__gdpr-link"
              title="Notice at Collection"
            >
              Notice at Collection
            </a>

            <a href="#" className="iubenda-cs-preferences-link footer__gdpr-link"
               style={{ display: "flex", gap: "4px" }}>
	              <img
	                style={{ width: "2rem" }}
	                src="/images/ccpa-opt-out.svg"
	                width="30"
	                height="14"
	                loading="lazy"
	                alt="California Consumer Privacy Act (CCPA) Opt-Out Icon"
	              />

              Your Privacy Choices
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
